import React from "react"
import PropTypes from "prop-types"
import {
  CardHeader,
  CardContent,
  Button,
  CardFooter,
  CardTitle,
  CardDescription,
} from "ksc-portal-common-components/shadcn"

const failure = ({ backToLogin, errorMessage }) => (
  <>
    <CardHeader className="flex flex-col items-center gap-4">
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Illustrations">
          <circle
            id="Ellipse 85"
            cx="33"
            cy="33"
            r="32"
            fill="#D1D5DB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Ellipse 84"
            cx="33.0005"
            cy="33"
            r="24.96"
            fill="#F7FAFB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector (Stroke)"
            d="M25.127 22.2217C24.3248 21.4194 23.0241 21.4194 22.2218 22.2217C21.4196 23.0239 21.4196 24.3246 22.2218 25.1269L30.0949 33L22.2218 40.8731C21.4196 41.6754 21.4196 42.9761 22.2218 43.7783C23.0241 44.5806 24.3248 44.5806 25.127 43.7783L33.0001 35.9052L40.8732 43.7783C41.6755 44.5806 42.9762 44.5806 43.7784 43.7783C44.5807 42.9761 44.5807 41.6754 43.7784 40.8731L35.9053 33L43.7784 25.1269C44.5807 24.3246 44.5807 23.0239 43.7784 22.2217C42.9762 21.4194 41.6755 21.4194 40.8732 22.2217L33.0001 30.0948L25.127 22.2217Z"
            fill="#B30009"
            stroke="#B30009"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </CardHeader>
    <CardContent className="flex flex-col items-center space-y-2">
      <CardTitle className="text-center text-2xl font-medium text-foreground">
        {errorMessage}
      </CardTitle>
      <CardDescription className="text-center text-sm text-muted-foreground">
        Please try again
      </CardDescription>
    </CardContent>
    <CardFooter className="flex justify-center">
      <Button variant="default" onClick={backToLogin} className="w-full">
        Try Again
      </Button>
    </CardFooter>
  </>
)

failure.propTypes = {
  backToLogin: PropTypes.func.isRequired,
}

export default failure
